export enum GroupContextType {
    CUSTOMER_GROUP = 'CUSTOMER_GROUP',
    CUSTOMER_COMPANY = 'CUSTOMER_COMPANY',
    SUPPLIER_GROUP = 'SUPPLIER_GROUP',
    SUPPLIER_COMPANY = 'SUPPLIER_COMPANY',
}
